import React from 'react';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';

type IStates = {
    visible: boolean;
    containerOffsetX: number;
    containerOffsetY: number;
    title: string;
};
type IProps = Record<string, never>;
export default class TitleTooltip extends React.Component<IProps, IStates> {
    public constructor(props) {
        super(props);
        this.state = {
            visible: false,
            title: '',
            containerOffsetX: 0,
            containerOffsetY: 0,
        };
    }

    public componentDidMount(): void {
        eventBus.on(EventKeys.UPDATE_TITLE_SHOW_STATE, this.updateTitleShowState);
    }

    public componentWillUnmount(): void {
        eventBus.off(EventKeys.UPDATE_TITLE_SHOW_STATE, this.updateTitleShowState);
    }

    public updateTitleShowState = (option): void => {
        const { title = '', containerOffsetX = 0, containerOffsetY = 0, visible = false } = option;
        this.setState({
            visible,
            title,
            containerOffsetX,
            containerOffsetY,
        });
    };
    public render() {
        const { title, containerOffsetX, containerOffsetY, visible } = this.state;
        return <Tooltip
            placement={'bottom'}
            title={title}
            containerOffsetX={containerOffsetX}
            containerOffsetY={containerOffsetY}
            visible={visible}
            style={{ position: 'absolute', left: 0, top: 0 }}
        >
            <div>{/* 空元素，用来挂tooltip */}</div>
        </Tooltip>;
    }
}
